export const normalizeExcelDate = (value: string | number): string => {
  if (typeof value === "number") {
    const date = new Date(Math.round((value - 25569) * 86400 * 1000));

    if (Number.isNaN(date.getTime())) return String(value);

    const d = String(date.getUTCDate()).padStart(2, "0");
    const m = String(date.getUTCMonth() + 1).padStart(2, "0");

    return `${d}/${m}/${date.getUTCFullYear()}`;
  }

  const str = String(value).trim();

  // YYYY-MM-DD or YYYY-MM-DDTHH:mm:ss (ISO)
  const iso = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (iso) return `${iso[3]}/${iso[2]}/${iso[1]}`;

  // YYYY/MM/DD
  const ymd = str.match(/^(\d{4})\/(\d{2})\/(\d{2})$/);
  if (ymd) return `${ymd[3]}/${ymd[2]}/${ymd[1]}`;

  // DD/MM/YYYY or D/M/YYYY (day-first — Spanish locale)
  const dmy = str.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (dmy)
    return `${dmy[1].padStart(2, "0")}/${dmy[2].padStart(2, "0")}/${dmy[3]}`;

  // DD-MM-YYYY or D-M-YYYY
  const dmyDash = str.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
  if (dmyDash)
    return `${dmyDash[1].padStart(2, "0")}/${dmyDash[2].padStart(2, "0")}/${dmyDash[3]}`;

  return str;
};
